import { call, put, select, takeLeading } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $file from 'modules/file';
import * as $auth from 'modules/auth';
import * as actions from '../actions';

const UserProfileToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const uploadCoverPhoto = function* ({ payload: file }) {
  yield put($ui.setTrue(UI.UserProfile.IsCoverPhotoUploading)());

  try {
    const token = yield select($auth.getToken);
    const publisherId = yield select($auth.getSelectedPublisherId);

    const imageUrl = yield call($file.uploadImage, file, {
      token,
      publisherId,
    });

    yield put(actions.uploadCoverPhotoSuccess(imageUrl));
  } catch {
    UserProfileToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message:
        'Something went wrong while uploading cover photo. Please, try again later or contact support',
    });
  } finally {
    yield put($ui.setFalse(UI.UserProfile.IsCoverPhotoUploading)());
    yield put(actions.uploadCoverPhotoFailure());
  }
};

const uploadProfilePhoto = function* ({ payload: file }) {
  yield put($ui.setTrue(UI.UserProfile.IsProfilePhotoUploading)());

  try {
    const token = yield select($auth.getToken);
    const publisherId = yield select($auth.getSelectedPublisherId);

    const imageUrl = yield call($file.uploadImage, file, {
      token,
      publisherId,
    });

    yield put(actions.uploadProfilePhotoSuccess(imageUrl));
  } catch {
    UserProfileToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message:
        'Something went wrong while uploading profile photo. Please, try again later or contact support',
    });
  } finally {
    yield put($ui.setFalse(UI.UserProfile.IsProfilePhotoUploading)());
    yield put(actions.uploadProfilePhotoFailure());
  }
};

export const uploadPhotosSaga = function* () {
  yield takeLeading(actions.uploadCoverPhoto, uploadCoverPhoto);
  yield takeLeading(actions.uploadProfilePhoto, uploadProfilePhoto);
};
